/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
    ContactTypeToJSONTyped,
} from './ContactType';

/**
 * 
 * @export
 * @interface GetContactsResponse
 */
export interface GetContactsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    name?: string | null;
    /**
     * Null for Type = ContactType.Default
     * @type {string}
     * @memberof GetContactsResponse
     */
    productName?: string | null;
    /**
     * 
     * @type {ContactType}
     * @memberof GetContactsResponse
     */
    type: ContactType;
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetContactsResponse
     */
    email?: string | null;
}



/**
 * Check if a given object implements the GetContactsResponse interface.
 */
export function instanceOfGetContactsResponse(value: object): value is GetContactsResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetContactsResponseFromJSON(json: any): GetContactsResponse {
    return GetContactsResponseFromJSONTyped(json, false);
}

export function GetContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'type': ContactTypeFromJSON(json['type']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GetContactsResponseToJSON(json: any): GetContactsResponse {
    return GetContactsResponseToJSONTyped(json, false);
}

export function GetContactsResponseToJSONTyped(value?: GetContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'productName': value['productName'],
        'type': ContactTypeToJSON(value['type']),
        'phone': value['phone'],
        'email': value['email'],
    };
}

